<template>
  <div class="mfa-introduction">
    <h5 class="title is-5">How to Set Up Multi-Factor Authentication (MFA)</h5>
    <section>
      <p>
        To ensure the safe use of Pescle, we have implemented security measures with multi-factor authentication. Please set up multi-factor authentication to protect your account information.
      </p>
      <img src="./img/introduction/0-1.png" alt="Explanation of setting up multi-factor authentication" />
    </section>
    <section class="margin-left">
      <hr>
      <details class="container">
        <summary class="title is-5">Setting Up Multi-Factor Authentication</summary>
        <div class="steps-container">
          <div class="step">
            <p><strong>(1)</strong> Confirm User Information: Menu⇒Profile</p>
            <img src="./img/introduction/1-1.png" alt="Explanation of confirming user information" />
          </div>
          <div class="step">
            <p>
              <strong>(2)</strong> Set Up Multi-Factor Authentication:
              Install the authentication app on your smartphone (Google Authenticator) + Next
            </p>
            <img src="./img/introduction/2-1.png" alt="Explanation of installing the authentication app on your smartphone" />
          </div>
          <div class="step">
            <p>
              <strong>(3)</strong> Set Up Multi-Factor Authentication:
              Google Authenticator App (Reference)
            </p>
            <img src="./img/introduction/3-1.png" alt="Explanation of the Google Authenticator app" />
            <br/>
            <a
              href="https://apps.apple.com/jp/app/google-authenticator/id388497605"
              target="_blank"
              rel="noopener noreferrer"
              >Google Authenticator App Store</a>
          </div>
          <div class="step">
            <p>
              <strong>(4)</strong> Scan the QR code with the <span class="highlight">authentication app</span> on your smartphone, and enter the verification code
            </p>
            <img src="./img/introduction/4-1.png" alt="Explanation of using the authentication app" />
          </div>
          <div class="step">
            <p>
              <strong>(5)</strong> Scan the QR code and enter the verification code using the authentication app on your smartphone (Example)
            </p>
            <table class="operation-table">
              <tr>
                  <th>Operation on the authentication app on your smartphone</th>
                  <th>Operation on PESCLE</th>
              </tr>
              <tr>
                  <td><img src="./img/introduction/5-1.png" alt="Image 1" width="700"></td>
                  <td><img src="./img/introduction/5-2.png" alt="Image 2" width="700"></td>
              </tr>
            </table>
          </div>
        </div>
      </details>
      <hr>
      <details class="container">
        <summary class="title is-5">Disabling Multi-Factor Authentication</summary>
        <div class="steps-container">
          <div class="step">
            <p><strong>(1)</strong> Confirm User Information: Menu⇒Profile</p>
            <img src="./img/disable/1-1.png" alt="Steps to disable MFA" />
          </div>
        </div>
      </details>
      <hr>
      <details class="container">
        <summary class="title is-5">Transferring During Smartphone Model Change</summary>
        <div class="steps-container">
          <div class="step">
            <p><strong>(1)</strong> Operations on the <span class="highlight">old device</span></p>
            <img src="./img/changeDevice/1-1.png" alt="Explanation for the old device during smartphone change" />
          </div>
          <div class="step">
            <p><strong>(2)</strong> Operations on the <span class="highlight">new device</span></p>
            <img src="./img/changeDevice/2-1.png" alt="Explanation for the new device during smartphone change" />
          </div>
        </div>
      </details>
      <hr>
    </section>
  </div>
</template>

<style>
.container {
  display: flex;
  flex-direction: column;
}
.steps-container {
  margin-left: 20px;
}
.step {
  margin-bottom: 20px;
}
.margin-left {
  margin-left: 50px;
}
.highlight {
  color: blue;
}
.operation-table {
  width: 100%;
  border-collapse: collapse;
}
.operation-table th, .operation-table td {
  border: 2px solid #000;
  padding: 10px;
}
</style>
